import { AtsTier } from "@nimble/core-client/types";

import type { SchoolData } from "@/types";

export const QUICK_APPLY_ATS_TIERS: AtsTier[] = [
  AtsTier.ATS_FULL,
  AtsTier.ATS_LITE,
];

export const getIsQuickApplyTier = (tier: AtsTier | null): boolean => {
  if (tier === null) {
    return false;
  }

  return QUICK_APPLY_ATS_TIERS.includes(tier);
};

export const getIsQuickApplySchool = (school: SchoolData): boolean =>
  getIsQuickApplyTier(school.ats_tier);
